/**
 * Чтение дизайн-токенов из JS.
 *
 * Canvas и Leaflet не понимают CSS-классы, но цвет им нужен. Брать его
 * отсюда, а не вписывать шестнадцатеричным числом: иначе конфетти и маркер
 * на карте остаются от старой палитры и не знают про тёмную тему.
 */

/** Значение CSS-переменной темы. Пустая строка, если токена нет. */
export function themeColor(token: string, fallback = '#000000'): string {
  if (typeof document === 'undefined') return fallback
  const value = getComputedStyle(document.documentElement).getPropertyValue(token).trim()
  return value || fallback
}
